import { Injectable } from '@angular/core';
import { first } from 'rxjs/operators';
import { ColorSchemaEnum } from '../enums/color-schema.enum';
import { StatusBarService } from './status-bar.service';
import { StoreKeysMainEnum, StoreKeysSubEnum } from '@core/enums/store-keys.enum';
import { StorageService } from "@core/services/storage.service";

@Injectable({ providedIn: 'root' })
export class ColorSchemaService {
    public enabledDarkTheme = false;
    public currentColorScheme = ColorSchemaEnum.DEFAULT;
    public prefersDarkMatch = false;

    constructor(
        private storageService: StorageService,
        private statusBarService: StatusBarService,
    ) {}

    public initSchema() {
        if (this.enabledDarkTheme) {
            const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');

            this.storageService
                .getSubItem<ColorSchemaEnum>(StoreKeysMainEnum.SETTINGS, StoreKeysSubEnum.COLOR_SCHEME)
                .pipe(first())
                .subscribe((currentScheme: ColorSchemaEnum) => {
                    if (!currentScheme || currentScheme === ColorSchemaEnum.DEFAULT) {
                        this.changeColorScheme(ColorSchemaEnum.DEFAULT);
                        //this.changeColorScheme(ColorSchemaEnum.LIGHT);
                    } else if (currentScheme === ColorSchemaEnum.DARK) {
                        this.changeColorScheme(ColorSchemaEnum.DARK);
                    } else {
                        this.changeColorScheme(ColorSchemaEnum.LIGHT);
                    }

                    prefersDark.addEventListener('change', mediaQuery => {
                        this.storageService
                            .getSubItem<ColorSchemaEnum>(StoreKeysMainEnum.SETTINGS, StoreKeysSubEnum.COLOR_SCHEME)
                            .pipe(first())
                            .subscribe((currentScheme: ColorSchemaEnum) => {
                                if (!currentScheme || currentScheme === ColorSchemaEnum.DEFAULT) {
                                    this.changeColorScheme(ColorSchemaEnum.DEFAULT);
                                } else if (currentScheme === ColorSchemaEnum.DARK) {
                                    this.changeColorScheme(ColorSchemaEnum.DARK);
                                } else {
                                    this.changeColorScheme(ColorSchemaEnum.LIGHT);
                                }
                            });
                    });
                });
        } else {
            this.changeColorScheme(ColorSchemaEnum.LIGHT);
        }
    }

    public changeColorScheme(scheme: ColorSchemaEnum) {
        if (!scheme) {
            return;
        }

        const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');

        if (prefersDark.matches) {
            document.body.classList.add('system-dark');
        }

        switch (scheme) {
            case ColorSchemaEnum.DEFAULT:
                this.toggleDarkTheme(prefersDark.matches);
                this.statusBarService.setStatusBarStyleDefault(prefersDark.matches).pipe(first()).subscribe();
                break;

            case ColorSchemaEnum.LIGHT:
                this.toggleDarkTheme(false);
                this.statusBarService.setStatusBarStyleLight().pipe(first()).subscribe();
                break;

            case ColorSchemaEnum.DARK:
                this.toggleDarkTheme(true);
                this.statusBarService.setStatusBarStyleDark().pipe(first()).subscribe();
                break;
        }

        this.storageService
            .setSubItem(StoreKeysSubEnum.COLOR_SCHEME, scheme, StoreKeysMainEnum.SETTINGS)
            .pipe(first())
            .subscribe(() => {
                this.currentColorScheme = scheme;
            });
    }

    private toggleDarkTheme(shouldAdd: boolean) {
        this.prefersDarkMatch = shouldAdd;
        document.body.classList.toggle('dark', shouldAdd);
    }
}
